<template>
  <b-container fluid>
    <b-row>
      <b-col class="px-0">
        <template v-if="levelComputed === 'testType'">
          <template v-if="testTypeSelected">
            <test-type-level-title
              v-model="tabSelectedComputed"
              :sequence-change="sequenceChange"
              :test-type-selected="testTypeSelected"
              @update-test-sequence="$emit('update-test-sequence', $event)"
              @reset-test-sequence="$emit('reset-test-sequence', $event)"
            />
          </template>
          <template v-else>
            <div class="p-1">
              รายการตรวจ
            </div>
          </template>
        </template>
        <template v-if="levelComputed === 'test'">
          <test-level-title
            v-model="tabSelectedComputed"
            :sequence-change="sequenceChange"
            :test-selected="testSelected"
            @back="backLevelHandler"
            @update-sub-test-sequence="$emit('update-sub-test-sequence', {type: 'subTest', password: $event})"
            @reset-sub-test-sequence="$emit('reset-sub-test-sequence', { type: 'subTest', password: $event})"
            @update-ref-range="$emit('update-ref-range', $event)"
          />
        </template>
        <template v-if="levelComputed === 'subTest'">
          <sub-test-level-title
            v-model="tabSelectedComputed"
            :test-selected="subTestSelected"
            :sequence-change="sequenceChange"
            @back="backLevelHandler"
            @update-sub-sub-test-sequence="$emit('update-sub-sub-test-sequence', { type: 'subSubTest', password: $event})"
            @reset-sub-sub-test-sequence="$emit('reset-sub-sub-test-sequence', { type: 'subSubTest', password: $event })"
            @update-ref-range="$emit('update-ref-range', $event)"
          />
        </template>
        <template v-if="levelComputed === 'subSubTest'">
          <sub-sub-test-level-title
            v-model="tabSelectedComputed"
            :test-selected="subSubTestSelected"
            @back="backLevelHandler"
            @update-ref-range="$emit('update-ref-range', $event)"
          />
        </template>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import TestTypeLevelTitle from "./DataTitle/TestTypeLevelTitle";
  import TestLevelTitle from "./DataTitle/TestLevelTitle";
  import SubTestLevelTitle from "./DataTitle/SubTestLevelTitle";
  import SubSubTestLevelTitle from "./DataTitle/SubSubTestLevelTitle";
  export default {
    name: "TestTitle",
    components: {SubSubTestLevelTitle, SubTestLevelTitle, TestLevelTitle, TestTypeLevelTitle},
    props: {
      testTypeSelected: {
        type: Object,
        default: () => null
      },
      tabSelected: {
        type: String,
        default: null
      },
      sequenceChange: {
        type: Boolean,
        default: false,
      },
      testSelected: {
        type: Object,
        default: () => null
      },
      subTestSelected: {
        type: Object,
        default: () => null
      },
      subSubTestSelected: {
        type: Object,
        default: () => null
      },
      level: {
        type: String,
        default: 'testType'
      }
    },
    computed: {
      tabSelectedComputed: {
        get() {
          return this.tabSelected
        },
        set(value) {
          this.$emit('update:tabSelected', value)
        }
      },
      levelComputed: {
        get() {
          return this.level
        },
        set(value) {
          this.$emit('update:level', value)
        }
      }
    },
    methods: {
      tabSelectedHandler(tab, level='testType') {
        this.tabSelectedComputed = tab
        this.levelComputed = level
      },
      backLevelHandler(level) {
        if (level === 'testType') {
          this.tabSelectedComputed = 'testType'
        } else if (level === 'test') {
          this.tabSelectedComputed = 'editTest'
        } else if (level === 'subTest') {
          this.tabSelectedComputed = 'editSubTest'
        }
        this.levelComputed = level;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .action-panel {
    opacity: 0;
    &.visible {
      opacity: 100%;
    }
  }

  .tab-button {
    &.active {
      background: #2E83D9 !important;
      color: white;
    }
  }

  .test-sequence-panel {
    border-top: 1px solid black;
  }
</style>